import React, { useState } from "react";
import { useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  requestChangeMember,
  changeCompanyModal,
  requestUpdateLicenseQuantity,
} from "../../../../../redux/actions/company";
import { TransparentButton, SolidButton } from "../../../../library/button";
import { Input } from "../../../../library/input";
import { Label } from "../../../../library/label";
import { Popup } from "../../../../library/popup";

import "./style.scss";

const Index = () => {
  const dispatch = useDispatch();

  const [licenses, setLicenses] = useState(null);

  const modalState = useSelector(
    (state) => state.company.showModals.changeMainSubscription
  );
  const companyDetails = useSelector(
    (state) => state.company.subscription?.main
  );
  const companyId = useSelector(
    (state) => state.activeCompany.activeCompany.id
  );

  const loading = useSelector(
    (state) => state.company?.updateLicenseQuantity.loading
  );

  const handleClose = () => {
    dispatch(changeCompanyModal({ changeMainSubscription: false }));
  };

  const clickChangeMember = () => {
    dispatch(
      requestUpdateLicenseQuantity({ amount: licenses, companyId: companyId })
    );
  };

  useEffect(() => {
    if (companyDetails && companyDetails.quantity) {
      setLicenses(companyDetails.quantity);
    }
  }, []);

  return (
    <Popup
      onClose={handleClose}
      show={modalState}
      title="Endre hovedabonnement"
      description="Du kan endre antall lisenser på hovedabonnementet ditt nedenfor. Endringene vil skje umiddelbart, men nytt beløp vil ikke bli trukket før neste forfallsdato."
      buttons={[
        <TransparentButton
          title="Avbryt"
          type="button"
          data-dismiss="modal"
          onClick={() => handleClose()}
        />,
        <SolidButton
          color="blue"
          title={loading ? "Oppdaterer.." : "Oppdater"}
          icon={
            loading ? <i className="fas fa-circle-notch fa-spin"></i> : null
          }
          onClick={() => clickChangeMember()}
          type="button"
        />,
      ]}
    >
      <div className="change-main-subscription-content-container">
        <div className="select-plan-container">
          <div className="single-selection-container active">
            <div className="inner-single-selection-container">
              <Row>
                <Col className="button-col my-auto">
                  <button className="select-button">
                    <i class="fad fa-circle"></i>
                  </button>
                </Col>
                <Col className="details-col my-auto">
                  <h4 className="plan-title">Standard abonnement</h4>
                  <p className="plan-description">
                    Pris oppgitt er eksklusiv moms
                  </p>
                </Col>
                <Col className="price-col my-auto">
                  <span className="price-display">
                    399kr<span className="small">per måned</span>
                  </span>
                </Col>
              </Row>
            </div>
          </div>
        </div>
        <Row className="info-row">
          <Col className="info-col">
            <Label version={1} weight="bold">
              Antall brukerlisenser
            </Label>
            <Input
              type="number"
              value={licenses}
              onChange={(e) => setLicenses(e.target.value)}
              placeholder="1"
              min={1}
              max={10}
            />
          </Col>
        </Row>
      </div>
    </Popup>
  );
};

export default Index;
